import FormWatch from '@/common/Form/FormWatch';
import { ReactElement } from 'react';
import SwitchInput from '@/common/SwitchInput';
import { SwitchInputTypes } from '@/common/SwitchInput/types';
import { fieldWrapper } from '@/components/Field';

const FormSwitch = ({
  name,
  ...props
}: {
  name: string;
  validate?: boolean;
} & Partial<SwitchInputTypes.Props>): ReactElement => {
  return (
    <FormWatch name={name}>
      {([checked], form) => (
        <SwitchInput type="switch" {...props} checked={!!checked} onChange={() => form.setValue(name, !checked, { shouldDirty: true })} />
      )}
    </FormWatch>
  );
};

export const SwitchField = fieldWrapper<SwitchInputTypes.Props>(FormSwitch, 'Switch');

export default FormSwitch;
